const isAuthorizedForCms = (roles: string[] | undefined) =>
    roles?.some(r => ['prepare:announcements', 'review:announcements'].includes(r)) || false;

export default isAuthorizedForCms;
